export default "__VITE_ASSET__DbIv1kNl__"